module.exports = __webpack_public_path__ + "mo/img/brand05.8917f340.png";